import { ConversationChat, NoteBook, SpellingCheck, TargetCorrect } from '@berlitz/icons'
import React from 'react'

const menu = {
  basic: [
    {
      tab: 1,
      child: <ConversationChat color="brand01" size="sm" />,
    },
    {
      tab: 2,
      child: <SpellingCheck color="brand01" size="sm" />,
    },
  ],
  full: [
    {
      tab: 1,
      child: <ConversationChat color="brand01" size="sm" />,
    },
    {
      tab: 2,
      child: <SpellingCheck color="brand01" size="sm" />,
    },
    {
      tab: 3,
      child: <NoteBook color="brand01" size="sm" />,
    },
    {
      tab: 4,
      child: <TargetCorrect color="brand01" size="sm" />,
    },
  ],
}

export default menu
